import React from 'react';

export const CandidateCardSkeleton: React.FC = () => {
  return (
    <div className='bg-white/60 backdrop-blur-xl rounded-3xl border border-white/20 shadow-xl p-8 animate-pulse'>
      <div className='flex items-start justify-between mb-6'>
        <div className='flex items-center gap-4'>
          <div className='w-16 h-16 bg-slate-200 rounded-2xl' />
          <div className='space-y-2'>
            <div className='h-5 w-32 bg-slate-200 rounded' />
            <div className='h-4 w-24 bg-slate-200 rounded' />
            <div className='h-3 w-20 bg-slate-200 rounded' />
          </div>
        </div>
        <div className='text-center'>
          <div className='w-14 h-14 bg-slate-200 rounded-2xl mb-1' />
          <div className='h-3 w-10 bg-slate-200 rounded' />
        </div>
      </div>

      <div className='mb-6'>
        <div className='h-4 w-20 bg-slate-200 rounded mb-2' />
        <div className='flex flex-wrap gap-2'>
          <div className='h-6 w-16 bg-slate-200 rounded-full' />
          <div className='h-6 w-20 bg-slate-200 rounded-full' />
          <div className='h-6 w-18 bg-slate-200 rounded-full' />
        </div>
      </div>

      <div className='mb-6'>
        <div className='h-4 w-24 bg-slate-200 rounded mb-2' />
        <div className='h-3 w-full bg-slate-200 rounded mb-1' />
        <div className='h-3 w-3/4 bg-slate-200 rounded' />
      </div>

      <div className='flex items-center justify-between'>
        <div className='h-6 w-24 bg-slate-200 rounded-full' />
        <div className='flex gap-2'>
          <div className='w-8 h-8 bg-slate-200 rounded-lg' />
          <div className='w-8 h-8 bg-slate-200 rounded-lg' />
          <div className='w-8 h-8 bg-slate-200 rounded-lg' />
        </div>
      </div>
    </div>
  );
};

export const CandidateTableSkeleton: React.FC = () => {
  return (
    <div className='bg-white/60 backdrop-blur-xl rounded-2xl border border-white/20 shadow-xl overflow-hidden'>
      <div className='p-6 border-b border-slate-200/50'>
        <div className='h-6 w-40 bg-slate-200 rounded animate-pulse' />
      </div>
      <div className='divide-y divide-slate-200/50'>
        { Array.from({ length: 6 }).map((_, index) => (
          <div key={index} className='p-6 animate-pulse'>
            <div className='flex items-center justify-between'>
              <div className='flex items-center gap-4'>
                <div className='w-12 h-12 bg-slate-200 rounded-xl' />
                <div className='space-y-2'>
                  <div className='h-4 w-32 bg-slate-200 rounded' />
                  <div className='h-3 w-24 bg-slate-200 rounded' />
                </div>
              </div>
              <div className='flex items-center gap-8'>
                <div className='flex gap-2'>
                  <div className='h-6 w-16 bg-slate-200 rounded-full' />
                  <div className='h-6 w-16 bg-slate-200 rounded-full' />
                </div>
                <div className='h-4 w-20 bg-slate-200 rounded' />
                <div className='h-8 w-8 bg-slate-200 rounded-lg' />
                <div className='flex gap-1'>
                  <div className='w-8 h-8 bg-slate-200 rounded-lg' />
                  <div className='w-8 h-8 bg-slate-200 rounded-lg' />
                  <div className='w-8 h-8 bg-slate-200 rounded-lg' />
                </div>
              </div>
            </div>
          </div>
        )) }
      </div>
    </div>
  );
};

export const SkeletonGrid: React.FC<{ count?: number }> = ({ count = 10 }) => {
  return (
    <div className='grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 2xl:grid-cols-5 gap-4'>
      { Array.from({ length: count }).map((_, index) => (
        <CandidateCardSkeleton key={index} />
      )) }
    </div>
  );
};
